import { call, put } from 'redux-saga/effects';

import { deleteRegistration } from '@api/registrations';
import { history, jurisdictionsRoutes } from '@routes';
import { toastError, toastSuccess } from '@store/notifications';
import {
  registrationsInfoDeleteSuccessAction,
  registrationsInfoDeleteFailureAction,
} from '@store/registrations/registrationsDetail/registrationsInfo/registrationsInfo.actions';

export const registrationsInfoDeleteSaga = function* ({ payload = {} }) {
  const { entityId, entityJurisdictionId, regId } = payload;

  try {
    yield call(deleteRegistration, regId);

    yield put([
      registrationsInfoDeleteSuccessAction(),
      toastSuccess({
        message: {
          defaultMessage: 'Registration deleted successfully.',
          id: 'pages.registrations.registration-info-delete.notification.success',
        },
      }),
    ]);

    yield call(
      history.replace,
      jurisdictionsRoutes.DETAIL.make({ entityId, entityJurisdictionId })
    );
  } catch (error) {
    const { nonFieldErrors, hasNonFieldError } = error.data || {};

    yield put(
      toastError({
        message: hasNonFieldError
          ? nonFieldErrors
          : {
              defaultMessage: 'Registration deletion failed.',
              id: 'pages.registrations.registration-info-delete.notification.error',
            },
      })
    );

    yield put(registrationsInfoDeleteFailureAction());
  }
};
